<template>
  <div :class="['tree-select', dropdownIsOpen ? 'open' : 'close', 'size-' + size]">
    <group-dropdown-menu
      :disabled="disabled"
      :explain="explain"
      :group-list="groupList"
      :width="width"
      @select="dropdownSelect"
      @show="dropdownIsOpen = true"
      @hide="dropdownIsOpen = false"
      :selected="multiple ? value || [] : value ? [value] : []"
    >
      <div class="group-dropdown-menu-reference" :class="disabled ? 'disabled' : ''">
        <div v-if="multiple" class="tree-select-tags">
          <input
            v-if="_.isEmpty(value)"
            class="el-input__inner pointer"
            type="text"
            autocomplete="off"
            placeholder="请选择"
            :disabled="disabled"
          />
          <el-tag
            v-for="val in value || []"
            :key="val"
            :closable="!disabled"
            size="small"
            type="info"
            @close="deleteTag(val)"
            disable-transitions
          >
            <span class="tree-select-tags-text">{{ _.get(valueLabelMap, val, noneLabel) }}</span>
          </el-tag>
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-input
          v-else
          class="single"
          :disabled="disabled"
          placeholder="请选择"
          :value="valueLabelMap[value]"
        >
          <template slot="suffix">
            <i
              class="el-select__caret el-input__icon el-icon-arrow-down"
              :class="valueLabelMap[value] ? 'value-icon' : 'select-icon'"
            ></i>
            <i
              v-if="valueLabelMap[value]"
              class="el-select__caret el-input__icon el-icon-circle-close close-icon"
              @click="handleClearClick"
            ></i>
          </template>
        </el-input>
      </div>
    </group-dropdown-menu>
  </div>
</template>

<script>
import GroupDropdownMenu from "@/components/UIComponents/GroupDropdownMenu/GroupDropdownMenu"
import { bfs } from "@/utils/algorithm"
export default {
  name: "tree-select",
  components: { GroupDropdownMenu },
  props: {
    value: [String, Array],
    groupList: {
      type: Array,
      default: () => [
        {
          label: "分组名",
          // title: "分组名", // 也可
          options: [{ label: "选项名", value: "选项值" }],
          children: [] // 子分组
        }
      ]
    },
    disabled: Boolean,
    multiple: Boolean,
    explain: {
      type: Boolean,
      default: false
    },
    noneLabel: {
      type: String,
      default: "选项不存在"
    },
    size: {
      type: String,
      default: "normal" // normal small
    }
  },
  computed: {
    valueLabelMap() {
      let map = {}
      bfs({
        arr: this.groupList,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(option => (map[option.value] = option.label))
        }
      })
      return map
    }
  },
  data() {
    return {
      width: "300",
      dropdownIsOpen: false
    }
  },
  mounted() {
    this.width = this.$el.getBoundingClientRect().width + ""
  },
  methods: {
    dropdownSelect({ value, label, control }) {
      let newValue
      if (this.multiple) {
        let curValue = this.value || []
        newValue = curValue.includes(value) ? curValue : curValue.concat(value)
      } else {
        newValue = value
      }
      this.emitVal(newValue)
      this.emitControl(label, control)
    },
    emitVal(value) {
      this.$emit("input", value)
    },
    deleteTag(item) {
      this.emitVal((this.value || []).filter(val => val != item))
    },
    emitControl(label, control) {
      this.$emit("change", { label: label, control: control })
    },
    handleClearClick() {
      this.$emit("input", null)
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-select {
  background: #ffffff;
  &.size-small {
    font-size: 14px;
    line-height: 32px;
    .el-input {
      .el-input__inner {
        height: 32px;
      }
    }
  }
  &::v-deep {
    .el-icon-arrow-down {
      transition: transform 0.3s ease;
    }
    &.open {
      .el-icon-arrow-down {
        transform: rotate(-180deg);
      }
    }
  }
  .tree-select-tags {
    min-height: 40px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    position: relative;
    padding-right: 32px;
    &:hover,
    &:focus {
      border-color: #2196f3 !important;
    }
    .el-tag {
      white-space: normal;
      min-height: 24px;
      height: unset;
      margin: 2px 0 2px 6px;
      ::v-deep {
        .el-tag__close {
          background-color: #c0c4cc;
        }
      }
    }
    .el-icon-arrow-down {
      position: absolute;
      right: 10px;
      color: #c0c4cc;
    }
    .el-input__inner {
      border: none;
      height: 38px;
      line-height: 38px;
    }
  }
  .disabled {
    background: #f6f7fa;
    cursor: not-allowed;
  }
  .single {
    .select-icon {
      display: block;
    }
    .value-icon {
      display: block;
    }
    .close-icon {
      display: none;
    }
    &:hover {
      .value-icon {
        display: none;
      }
      .close-icon {
        display: block;
      }
    }
  }
}
</style>
